import {
  ACTIVE_AUTO_RENEW_MONTHLY_COPY,
  ACTIVE_AUTO_RENEW_MONTHLY_WITH_DISCOUNT_DURATION_IN_MONTHS_COPY,
  ACTIVE_AUTO_RENEW_MONTHLY_WITH_DISCOUNT_DURATION_ONCE_COPY,
  ACTIVE_AUTO_RENEW_YEARLY_COPY,
  ACTIVE_AUTO_RENEW_YEARLY_WITH_DISCOUNT_DURATION_ONCE_COPY,
} from 'src/common/constants/localizations/subscription';
import { stripeDurationTypes } from 'src/common/constants/subscription/coupon';
import billingFrequency from 'src/common/utils/subscription/billingPeriod';

export default function getPaymentDetailsCopy(billingPeriod, durationType) {
  if (durationType === stripeDurationTypes.once) {
    return billingPeriod === billingFrequency.yearly
      ? ACTIVE_AUTO_RENEW_YEARLY_WITH_DISCOUNT_DURATION_ONCE_COPY
      : ACTIVE_AUTO_RENEW_MONTHLY_WITH_DISCOUNT_DURATION_ONCE_COPY;
  }

  if (
    durationType === stripeDurationTypes.repeating &&
    billingPeriod === billingFrequency.monthly
  ) {
    return ACTIVE_AUTO_RENEW_MONTHLY_WITH_DISCOUNT_DURATION_IN_MONTHS_COPY;
  }

  return billingPeriod === billingFrequency.yearly
    ? ACTIVE_AUTO_RENEW_YEARLY_COPY
    : ACTIVE_AUTO_RENEW_MONTHLY_COPY;
}
